const DialCodes = [    {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
}
];

export default DialCodes;
    